import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d7pmygnptu: FaireBrandEntity = {
  token: "b_d7pmygnptu",
  type: "brand",
  name: "Ashbury Bloom",
  avatarUrl:
    "https://cdn.faire.com/fastly/70589415daf41ea0407b7e8849c6a97c47f87ee87cda0ed82061e0f0da80b270.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8b5dec50ed59a3d592c6ecc5ccdbdbc3d9ed6c0bd1dc9beacc36790a967373df.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/70589415daf41ea0407b7e8849c6a97c47f87ee87cda0ed82061e0f0da80b270.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8b5dec50ed59a3d592c6ecc5ccdbdbc3d9ed6c0bd1dc9beacc36790a967373df.jpeg",
  location: "Mount Hope, ON, CAN",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 28,
  isTopShop: true,
  isInsider: false,
  description:
    "Our journey to create bath, body and home products that are good for the body and the environment started after a family member passed away from cancer at an early age. We wanted to create natural products with ingredients that are simple, clean and chemical-free to help our family and customers foster health, wellness and self-care. \n\nWe handcraft natural and sustainable products using only the finest plant-based ingredients, herbs and botanicals that are sourced from some of the herbs we grow, local farmers and suppliers. Our products are gluten-free, vegan, cruelty-free, paraben/phthalate-free and made without harsh chemical preservatives. \n\nBeing passionate isn’t just about knowing, it’s also about feeling. We feel passionate about the quality and the benefits that our products provide, and believe in the link between wellness and nature. We hope you enjoy our products as much as we enjoy creating them!\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:36.961Z",
    importedBy: "entity-db-cli",
  },
};
